import Theme from '@adsk/alloy-react-theme';

export const imageStyle = {
  height: '120px',
};

export const imageSectionStyle = {
  display: 'flex',
  'flex-direction': 'row',
  'justify-content': 'space-between',
  border: `1px solid ${Theme.colors.charcoal200}`,
  'border-radius': '4px',
};

export const learningCenterStyle = {
  'align-items': 'center',
  display: 'flex',
  'flex-direction': 'row',
  'justify-content': 'space-between',
  'padding-left': '16px',
};

export const bodyStyle = {
  padding: '23px 32px',
};

export const imageTextStyle = {
  padding: '29px 0  0 16px',
};

export const imageTextIntroductionStyle = {
  ...Theme.typography.bodySmallBold,
};

export const imageTextDescriptionStyle = {
  ...Theme.typography.bodySmall,
};

export const imageTextLinkStyle = {
  ...Theme.typography.bodySmall,
};

export const contentSectionStyle = {
  padding: '21px 0 8px 0',
};

export const footerSectionStyle = {
  borderTop: `1px solid ${Theme.colors.charcoal200}`,
  paddingTop: '24px',
};

export const contentTitleStyle = {
  ...Theme.typography.bodyMediumBold,
  paddingBottom: '12px',
};

export const footerHelpLinkStyle = {
  display: 'flex',
  'flex-direction': 'row',
  alignItems: 'center',
};

export const footerHelpLinkTextStyle = {
  paddingRight: '15px',
  ...Theme.typography.bodyMediumBold,
};
